import { isHeaderLayoutWithPhotos } from '@shared/utils/websiteDesign';
import type { SupportedHeaderPhotoLayoutSchema } from '@shared/types/WebsiteHeaderSettings.types';

type GetWelcomePagePhotoUrlArgs = Readonly<{
  dataJSON: SupportedHeaderPhotoLayoutSchema | undefined;
  isEventPhotoV2UrlMigrationEnabled: boolean;
  eventPhotoV2Url?: string | null;
  eventPhotoUrl?: string | null;
  isGeneralEvent: boolean;
}>;

export const getWelcomePagePhotoUrl = ({
  dataJSON,
  isEventPhotoV2UrlMigrationEnabled,
  eventPhotoV2Url,
  eventPhotoUrl,
  isGeneralEvent,
}: GetWelcomePagePhotoUrlArgs): string | null => {
  const headerPhotoUrl = dataJSON && isHeaderLayoutWithPhotos(dataJSON) ? dataJSON.photos[0]?.url : null;
  const fallbackPhotoUrl = isGeneralEvent || isEventPhotoV2UrlMigrationEnabled ? eventPhotoV2Url : eventPhotoUrl || null;
  return headerPhotoUrl || fallbackPhotoUrl || null;
};
